import createRouter from 'router5'
import browserPlugin from 'router5-plugin-browser'
import type allRoutes from 'web-client/router/routes'

export default function configureRouter(routes: typeof allRoutes) {
  const router = createRouter(routes, {
    defaultRoute: 'home',
    queryParamsMode: 'loose',
  })

  router.usePlugin(browserPlugin())

  return router
}
